import { TableRow } from '@mui/material';

const Row = ({ children, ...props }) => {
    return <TableRow {...props}>{children || ''}</TableRow>;
};

export default Row;
